import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  LocalizePropType,
  selectUser,
  setShowHomeWT,
  withTextLocalizer,
  selectBrandSettings,
} from 'getaway-data-layer';
import HomeView from './HomeView';
import { showAboutDialog } from '../../../utils/dialogsHelpers';
import config from '../../../env.config';
import packageInfo from '../../../../package.json';
import { navigateTo } from '../../../utils';
import { useHistory } from 'react-router-dom';

type Props = {
  localize: LocalizePropType;
};
const HomeContainer = ({ localize }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  // @ts-ignore
  const sliderRef = useRef();
  const user = useSelector(selectUser);
  const brandSettings = useSelector(selectBrandSettings);
  const [sliderIndex, setSliderIndex] = useState(0);

  const isSignInWithEmailEnabled =
    brandSettings?.accountSettings?.signInWithEmailEnabled;

  const onClickNext = () => {
    dispatch(setShowHomeWT(false));
    navigateTo(history, '/signup');
  };

  const onClickGuest = () => {
    dispatch(setShowHomeWT(false));
  };

  const afterSlide = (index: number) => {
    setSliderIndex(index);
    if (index === 2) {
      dispatch(setShowHomeWT(false));
      navigateTo(history, '/signup');
    }
  };

  const onClickLogin = () => {
    dispatch(setShowHomeWT(false));
    isSignInWithEmailEnabled && window.location.hostname !== 'localhost'
      ? navigateTo(history, '/email-login')
      : navigateTo(history, '/login');
  };

  const onClickVersionHeader = () => {
    showAboutDialog(
      config.brand.xBrandId!!,
      localize,
      `© GETAWAY・v${packageInfo.version}`
    );
  };

  return (
    <HomeView
      localize={localize}
      user={user!}
      sliderIndex={sliderIndex}
      sliderRef={sliderRef}
      onClickNext={onClickNext}
      onClickGuest={onClickGuest}
      afterSlide={afterSlide}
      onClickLogin={onClickLogin}
      onClickVersionHeader={onClickVersionHeader}
    />
  );
};

export default withTextLocalizer(HomeContainer);
